import styled from 'styled-components'
import { color } from '@telus-uds/palette-allium'

export const PromoCodeLink = styled.a`
  text-decoration: underline;
  font-weight: 700;
  color: ${color.purpleTelus};
  cursor: pointer;
`

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 5.625rem 3.438rem;
  margin: 0.625rem 0rem 2rem;
  position: static;
  width: 23rem;
  height: 15.5rem;
  background-color: rgba(244, 244, 247, 0.97);
`

export const StyledDiv = styled.div`
  > div {
    padding: 0;
  }
  width: 100%;
`
